import { Theme } from '@mui/material'
import { makeStyles } from '@mui/styles'

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    width: '100%',
    heigth: '66px',
    margin: 0,
    marginTop: '0.5rem',
    marginBottom: '0.75rem',
    padding: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },

  container: {
    width: 'auto',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-start',
    gap: '1rem',
    padding: 0,
  },

  hero: {
    display: 'flex',
    flexDirection: 'column',
    textAlign: 'left',
  },

  title: {
    fontFamily: 'Sora',
    fontWeight: '400',
    fontSize: '1.5rem',
    lineHeight: '2rem',
    color: `${theme.palette.secondary.contrastText} !important`,
  },

  subtitle: {
    paddingTop: '2px',
    fontFamily: 'Nunito',
    fontWeight: '400',
    fontSize: '14.5px',
    lineHeight: '20px',
    color: `${theme.palette.secondary.contrastText} !important`,
    opacity: 0.6,
  },

  button: {
    borderRadius: '0.5rem',
    backgroundColor: theme.palette.primary.main,
    margin: 0,
    padding: '0 1.375rem',
    fontFamily: 'Sora',
    fontWeight: '600',
    fontSize: '15px',
    lineHeight: '46px',
    color: `${theme.palette.primary.contrastText} !important`,
    textDecoration: 'none',
  },
}))

export { useStyles }
